import {
  createContactRequest,
  fetchContactRequest,
  updateContactRequest,
  fetchContactsRequest
} from "../api/index";
import { handleErrorRequest } from "../helpers/api";
import _ from "lodash";
import { createActions, handleActions } from "redux-actions";
import {
  payloadIdentity,
  simplePayloadMutation,
  resetMutation
} from "../helpers/redux";
import { createSelector } from "reselect";

const contactsState = state => state.contacts;

export const selectors = {
  isLoadingSubmitContact: createSelector(
    contactsState,
    ({ submittingContact }) => submittingContact
  ),
  getFailureSubmitContact: createSelector(
    contactsState,
    ({ failSubmitContact }) => failSubmitContact
  ),
  isSuccessSubmitContact: createSelector(
    contactsState,
    ({ successSubmitContact }) => successSubmitContact
  ),
  getContacts: createSelector(
    contactsState,
    ({ contacts }) => contacts
  ),
  getCurrentContact: createSelector(
    contactsState,
    ({ currentContact }) => currentContact
  )
};

const createdActions = createActions({
  contacts: {
    CREATE_CONTACT_ATTEMPT: null,
    CREATE_CONTACT_SUCCESS: null,
    CREATE_CONTACT_FAILURE: payloadIdentity("failMessage"),
    UPDATE_CONTACT_ATTEMPT: null,
    UPDATE_CONTACT_SUCCESS: null,
    UPDATE_CONTACT_FAILURE: payloadIdentity("failMessage"),
    DELETE_CONTACT_ATTEMPT: null,
    DELETE_CONTACT_SUCCESS: null,
    DELETE_CONTACT_FAILURE: payloadIdentity("failmessage"),
    FETCH_CONTACT_ATTEMPT: null,
    FETCH_CONTACT_SUCCESS: null,
    FETCH_CONTACT_FAILURE: payloadIdentity("failMessage"),
    FETCH_CONTACTS_ATTEMPT: null,
    FETCH_CONTACTS_SUCCESS: null,
    FETCH_CONTACTS_FAILURE: payloadIdentity("failMessage"),
    SET_CURRENT_CONTACT: payloadIdentity("currentContact"),
    SET_CONTACTS: payloadIdentity("contacts"),
    RESET_STATE: payloadIdentity("toOmit")
  }
}).contacts;

const {
  createContactAttempt,
  createContactSuccess,
  createContactFailure,
  updateContactAttempt,
  updateContactSuccess,
  updateContactFailure,
  fetchContactAttempt,
  fetchContactSuccess,
  fetchContactFailure,
  setCurrentContact,
  fetchContactsAttempt,
  fetchContactsSuccess,
  fetchContactsFailure,
  setContacts
} = createdActions;

const createContact = ({ dealer_id, customer_id, data }) => async (
  dispatch,
  getState
) => {
  dispatch(createContactAttempt());
  let jwt = _.get(getState(), "auth.user.jwt", "");
  const { response, error } = await createContactRequest({
    data: { contact: data },
    customer_id,
    dealer_id,
    jwt
  });
  if (response) {
    dispatch(createContactSuccess());
    return Promise.resolve({ response });
  } else {
    dispatch(createContactFailure(handleErrorRequest(error)));
    return Promise.resolve({ error });
  }
};

const fetchContact = ({ dealer_id, customer_id, contact_id }) => (
  dispatch,
  getState
) => {
  dispatch(fetchContactAttempt());
  let jwt = _.get(getState(), "auth.user.jwt", "");
  return fetchContactRequest({ contact_id, customer_id, dealer_id, jwt }).then(
    ({ response, error }) => {
      if (response) {
        dispatch(fetchContactSuccess());
        dispatch(setCurrentContact(response.data));
        return Promise.resolve(response.data);
      } else {
        dispatch(fetchContactFailure(handleErrorRequest(error)));
        return Promise.reject(error);
      }
    }
  );
};

const fetchContacts = ({ dealer_id, customer_id }) => (dispatch, getState) => {
  dispatch(fetchContactsAttempt());
  dispatch(setContacts(null));
  let jwt = _.get(getState(), "auth.user.jwt", "");
  return fetchContactsRequest({ dealer_id, customer_id, jwt }).then(
    ({ response, error }) => {
      if (response) {
        dispatch(fetchContactsSuccess());
        dispatch(setContacts(response.data));
        return Promise.resolve(response.data);
      } else {
        dispatch(fetchContactsFailure(handleErrorRequest(error)));
        return Promise.reject(error);
      }
    }
  );
};

const updateContact = ({ dealer_id, customer_id, contact_id, data }) => async (
  dispatch,
  getState
) => {
  dispatch(updateContactAttempt());
  let jwt = _.get(getState(), "auth.user.jwt", "");
  const { response, error } = await updateContactRequest({
    dealer_id,
    customer_id,
    contact_id,
    data: { contact: data },
    jwt
  });
  if (response) {
    dispatch(updateContactSuccess());
    dispatch(setCurrentContact(null));
    return Promise.resolve({ response });
  } else {
    dispatch(updateContactFailure(handleErrorRequest(error)));
    return Promise.resolve({ error });
  }
};

export const actions = {
  createContact,
  fetchContact,
  fetchContacts,
  updateContact,
  ...createdActions
};

export const initialState = {
  submittingContact: false,
  failSubmitContact: null,
  successSubmitContact: false,
  fetchingContact: false,
  failFetchContact: null,
  successFetchContact: false,
  currentContact: null,
  fetchingContacts: false,
  failFetchContacts: null,
  successFetchContacts: false,
  contacts: [],
  currentPage: 1,
  totalPages: 1
};

export default handleActions(
  {
    contacts: {
      CREATE_CONTACT_ATTEMPT: (state, action) => ({
        ...state,
        submittingContact: true,
        failSubmitContact: null,
        successSubmitContact: false
      }),
      CREATE_CONTACT_SUCCESS: (state, action) => ({
        ...state,
        submittingContact: false,
        failSubmitContact: null,
        successSubmitContact: true
      }),
      CREATE_CONTACT_FAILURE: (state, action) => ({
        ...state,
        submittingContact: false,
        failSubmitContact: action.failMessage,
        successSubmitContact: false
      }),
      UPDATE_CONTACT_ATTEMPT: (state, action) => ({
        ...state,
        submittingContact: true,
        failSubmitContact: null,
        successSubmitContact: false
      }),
      UPDATE_CONTACT_SUCCESS: (state, action) => ({
        ...state,
        submittingContact: false,
        failSubmitContact: null,
        successSubmitContact: true
      }),
      UPDATE_CONTACT_FAILURE: (state, action) => ({
        ...state,
        submittingContact: false,
        failSubmitContact: action.failMessage,
        successSubmitContact: false
      }),
      FETCH_CONTACT_ATTEMPT: (state, action) => ({
        ...state,
        fetchingContact: true,
        failFetchContact: null,
        successFetchContact: false
      }),
      FETCH_CONTACT_SUCCESS: (state, action) => ({
        ...state,
        fetchingContact: false,
        failFetchContact: null,
        successFetchContact: true
      }),
      FETCH_CONTACT_FAILURE: (state, action) => ({
        ...state,
        fetchingContact: false,
        failFetchContact: action.failMessage,
        successFetchContact: false
      }),
      FETCH_CONTACTS_ATTEMPT: (state, action) => ({
        ...state,
        fetchingContacts: true,
        failFetchContacts: null,
        successFetchContacts: false
      }),
      FETCH_CONTACTS_SUCCESS: (state, action) => ({
        ...state,
        fetchingContacts: false,
        failFetchContacts: null,
        successFetchContacts: true
      }),
      FETCH_CONTACTS_FAILURE: (state, action) => ({
        ...state,
        fetchingContacts: false,
        failFetchContacts: action.failMessage,
        successFetchContacts: false
      }),
      SET_CURRENT_CONTACT: simplePayloadMutation,
      SET_CONTACTS: simplePayloadMutation,
      RESET_STATE: resetMutation(initialState)
    }
  },
  initialState
);
